"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = FieldSet;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var isNestedFieldSet = function isNestedFieldSet(element) {
  return typeof element.type !== 'undefined' && typeof element.type !== 'string' && element.type.displayName === 'FieldSet';
};

var mapPropsToChildren = function mapPropsToChildren(props) {
  return _react.Children.map(props.children, function (kid) {
    var newProps = {};

    if (isNestedFieldSet(kid)) {
      newProps.nested = true;
    }

    if (props.toolbar) {
      newProps.toolbar = true;
    }

    if (Object.keys(newProps).length) {
      return (0, _react.cloneElement)(kid, newProps);
    }

    return kid;
  });
};

function FieldSet(props) {
  var classes = (0, _classnames["default"])({
    'zsg-form-fieldset': true,
    'zsg-toolbar-form-fieldset': props.toolbar
  }, props.className);
  var children = mapPropsToChildren(props);
  var legend;

  if (props.legend) {
    var legendClasses = (0, _classnames["default"])({
      'zsg-form-legend': true,
      'zsg-form-legend_sm': props.nested,
      'zsg-toolbar-label': props.toolbar
    });
    legend = _react["default"].createElement("legend", {
      className: legendClasses
    }, props.legend);
  }

  return _react["default"].createElement("fieldset", {
    className: classes
  }, legend, children);
}

FieldSet.displayName = 'FieldSet';
FieldSet.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   Additional classes to add to the root element
   **/
  className: _propTypes["default"].string,

  /**
   Any React node, rendered inside the <legend> tag
   **/
  legend: _propTypes["default"].node,
  nested: _propTypes["default"].bool,
  toolbar: _propTypes["default"].bool,

  /**
   Any React nodes, including other FieldSets
   **/
  children: _propTypes["default"].node
} : {};


//////////////////
// WEBPACK FOOTER
// ./~/@zillow/react-zsg/FieldSet/index.js
// module id = 513
// module chunks = 0